import { render, staticRenderFns } from "./PromotionErrorModal.vue?vue&type=template&id=38d7eb32&scoped=true&"
import script from "./PromotionErrorModal.vue?vue&type=script&lang=js&"
export * from "./PromotionErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./PromotionErrorModal.vue?vue&type=style&index=0&id=38d7eb32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d7eb32",
  null
  
)

export default component.exports